export type BusinessVertical = 'trades' | 'restaurant';

export function normalizeVertical(value?: string | null): BusinessVertical {
  return value === 'restaurant' ? 'restaurant' : 'trades';
}

export function isRestaurantVertical(value?: string | null): boolean {
  return value === 'restaurant';
}

export const TRADES_INDUSTRIES = [
  'Locksmith', 'HVAC', 'Plumbing', 'Electrical', 'Roofing', 'Landscaping',
  'Towing', 'Auto Repair', 'Cleaning', 'Pest Control', 'Garage Door', 'Other',
] as const;

export const RESTAURANT_INDUSTRIES = [
  'Restaurant', 'Pizza', 'Coffee Shop', 'Fast Casual', 'QSR', 'Bar', 'Bakery', 'Other',
] as const;

export function industriesForVertical(vertical: BusinessVertical): readonly string[] {
  return vertical === 'restaurant' ? RESTAURANT_INDUSTRIES : TRADES_INDUSTRIES;
}

export function defaultIndustryForVertical(vertical: BusinessVertical): string {
  return vertical === 'restaurant' ? 'Restaurant' : 'Locksmith';
}

export function onboardingStepCount(vertical: BusinessVertical): number {
  return 5;
}
